import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Keyboard = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M.334 4.018h15.333v8.666H.334V4.018ZM15 4.684H1v7.333h14V4.684Z" />
      <path d="M3.334 7.35h-.667a.333.333 0 1 1 0-.666h.667a.333.333 0 1 1 0 .666ZM6.668 7.35h-.667a.333.333 0 1 1 0-.666h.667a.333.333 0 0 1 0 .666ZM10 7.35h-.667a.333.333 0 1 1 0-.666H10a.333.333 0 1 1 0 .666ZM13.334 7.35h-.667a.333.333 0 1 1 0-.666h.667a.333.333 0 1 1 0 .666ZM3.334 10.018h-.667a.333.333 0 0 1 0-.666h.667a.333.333 0 1 1 0 .666ZM10.001 10.018h-4a.333.333 0 1 1 0-.666h4a.333.333 0 1 1 0 .666ZM13.334 10.018h-.667a.333.333 0 1 1 0-.666h.667a.333.333 0 1 1 0 .666Z" />
    </svg>
  );
};

Keyboard.category = 'product-category';

Keyboard.displayName = 'Keyboard';
